module.exports = __webpack_public_path__ + "img/icon-globe.7e1ea534.svg";